import React, { useEffect, useState, useRef } from "react"
import MetaTags from "react-meta-tags"
import PropTypes from "prop-types"
import { withRouter, Link, useLocation } from "react-router-dom"
import { isEmpty, set } from "lodash"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator"
import cellEditFactory from "react-bootstrap-table2-editor"
import * as Yup from "yup"
import { useFormik } from "formik"
// import makeAnimated from "react-select/animated";
import DeleteModal from "../../components/Common/DeleteModal"

import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import * as moment from "moment"

import { Card, CardBody, Col, Container, Row } from "reactstrap"

//redux
import { useSelector, useDispatch } from "react-redux"

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"



import {
  getCustomers as onGetCustomers,
  addNewVector as onAddNewVector,
  updateVector as onUpdateVector,
  deleteVector as onDeleteVector,
  getAuthUsers as onGetAuthUser,
  updateCustomerField,
  getCustomersSuccess,
} from "store/actions"

import Columns from "./Columns"
import { expandRow } from "./CustomerDetails"

import FilterComponentForCustomers from "components/Common/filterComponentForCustomers"
import { removeEmptyValues } from "common/CommonFunction"
import GenerateInvoice from "./GenerateInvoice"
import OrderForm from "pages/Orders/OrderForm"
import OrdersModel from "./OrdersModel"
import InvoiceHistoryModel from "./InvoiceHistoryModel"

const Customers = props => {
  const dispatch = useDispatch()
  let location = useLocation()

  const paginate = { size: 50, page: 1 }

  const [order, setVector] = useState(null)

  const [path, setPath] = useState(location)


  // const design = useSelector(state => state);
  const { customers, designers,sales } = useSelector(state => ({
    customers: state.Customers.customers,
    designers: state.Login.designers,
    sales: state.Login.sales

  }))

  // let invoiceObject = {};

  const [modal, setModal] = useState(false)
  const [modal1, setModal1] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [isRight, setIsRight] = useState(false)
  const [designersList, setDesignersList] = useState({})
  const [salesList, setSalesList] = useState({})
  const [deleteModal, setDeleteModal] = useState(false)
  const [filter, setFilter] = useState({})
  const [open, setOpen] = useState(false)
  const [orderFormModelOpen, setOrderFormModelOpen] = useState(false)
  const [invoiceObject, setInvoiceObject] = useState({});
  const [recvalue, selectValue] = useState({})
  
  const [orderObject, setOrderObject] = useState({})

  const [toggleInvoiceHistory, setToggleInvoiceHistory] = useState(false)

  const toggleRtCanvas = row => {
    setOrderObject(row)
    setOpen(!open)
  }

  useEffect(() => {
    setDesignersList(designers)
    setSalesList(sales)
  },[designers, sales])

    useEffect(() => {
    setPath(location.pathname)
    if(location.pathname === "/customers" || location.pathname === "/all-customers" && customers.hasOwnProperty("docs") ){
      console.log("reset customers")
      dispatch(getCustomersSuccess([]))
    }
  }, [location])


  const toggleInvoiceHistoryModel = data =>{
    setInvoiceObject(data)
    setToggleInvoiceHistory(!toggleInvoiceHistory)
  }

  const toggleOrderFormModel = (rec, order) => {
    selectValue({rec, order})
    setOrderFormModelOpen(!orderFormModelOpen)
  }
  const toggleOrderFormModelClose = () => {
    setOrderFormModelOpen(!orderFormModelOpen)
  }
  const [pageOptions, setPageOptions] = useState({
    sizePerPage: paginate.size,
    page: paginate.page,
    totalSize: paginate.size,
    custom: true,
  })

  const handleTableChange = (type, { page, sizePerPage }) => {
    const json = filterFunction(page)
    const queryString = new URLSearchParams({
      ...json.params,
      ...json.paginate,
    }).toString()
    window.history.pushState({}, "", `${path}?${queryString}`)
    dispatch(onGetCustomers(json))
  }

  const handleFilterClick = searchParam => {
    
    let json = removeEmptyValues(JSON.parse(JSON.stringify(searchParam)))
    console.log("searchParam", json)
    setFilter(json)
    json = {
      params: { designation: "User", ...json },
      paginate: paginate,
    }
    const queryString = new URLSearchParams({
      ...json.params,
      ...json.paginate,
    }).toString()

    window.history.pushState({}, "", `${path}?${queryString}`)

    dispatch(onGetCustomers(json))
  }

  function filterFunction(page) {
    const queryParams = new URLSearchParams(location.search)

    const params = { designation: "User", ...filter }

    for (let [key, value] of queryParams.entries()) {
      params[key] = value
    }

    params.page = params.page > 1 ? params.page : page
    delete params.size

    let json = { params, paginate: { size: paginate.size, page: params.page } }
    return json
  }

  const toggleViewModal = () => setModal1(!modal1)

  const toLowerCase1 = str => {
    return str === "" || str === undefined ? "" : str.toLowerCase()
  }

  useEffect(() => {
    if (!customers.hasOwnProperty("docs")) {
      const json = filterFunction(1)
      setFilter(json)
      dispatch(onGetCustomers(json))
    }
    setPageOptions({
      sizePerPage: customers.limit,
      page: customers.offset,
      totalSize: customers.totalDocs,
      custom: true,
    })
  }, [dispatch, customers])

  // useEffect(() => {
  //   if (!designerUsers.hasOwnProperty("docs")) {
  //     dispatch(onGetAuthUser())
  //   }

  //   setDesigners(designerUsers)
  // }, [dispatch, designerUsers])

  
  // useEffect(() => {
  //   if (!isEmpty(customers) && !!isEdit) {
  //     setVectorList(customers)
  //     setIsEdit(false)
  //   }
  // }, [customers])

  const toggle = () => {
    if (modal) {
      setModal(false)
      setVector(null)
    } else {
      setModal(true)
    }
  }

  const handleVectorClick = arg => {
    const order = arg

    setVector({
      id: order.id,
      orderId: order.orderId,
      billingName: order.billingName,
      orderdate: order.orderdate,
      total: order.total,
      paymentStatus: order.paymentStatus,
      paymentMethod: order.paymentMethod,
      badgeclass: order.badgeclass,
    })

    setIsEdit(true)

    toggle()
  }

  var node = useRef()
  const onPaginationPageChange = page => {
    if (
      node &&
      node.current &&
      node.current.props &&
      node.current.props.pagination &&
      node.current.props.pagination.options
    ) {
      node.current.props.pagination.options.onPageChange(page)
    }
  }

  

  const handleValidDate = date => {
    const date1 = moment(new Date(date)).format("DD MMM Y")
    return date1
  }

  const toggleRightCanvas = () => {
    setIsRight(!isRight)
  }

  const defaultSorted = [
    {
      dataField: "orderId",
      order: "desc",
    },
  ]
  const handleChange = (oldValue, newValue, row, column, done) => {
    dispatch(updateCustomerField({[column.dataField]:newValue, _id: row._id}))
  }
  const [deleteCustomer, setDeletedCustomer] = useState();
  const handleDeleteCustomer = e => {
    dispatch(updateCustomerField({delete: true, _id: deleteCustomer._id}))
    // customers.docs.map(t => {
    //   t._id === deleteCustomer._id
    //   delete t;
    // })
    
    setDeleteModal(!deleteModal)
  }

  const onClickDelete = customer => {
    setDeletedCustomer(customer)
    
    setDeleteModal(!deleteModal)
    // dispatch(onDeleteVector(order._id))
  }

  return (
    <React.Fragment>
      {/* <OffCanvasModel isRight={isRight} toggleRightCanvas={toggleRightCanvas} /> */}
      {/* <CustomersModal isOpen={modal1} toggle={toggleViewModal} /> */}
      <DeleteModal
        show={deleteModal}
        onDeleteClick={e => handleDeleteCustomer(e)}
        onCloseClick={() => setDeleteModal(false)}
      />

      <div className="page-content">
        <MetaTags>
          <title>Customers</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs title="Customers" breadcrumbItem="Customers" />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <PaginationProvider
                    pagination={paginationFactory(pageOptions)}
                    keyField="_id"
                    columns={Columns(
                      toggle,
                      handleValidDate,
                      handleVectorClick,
                      onClickDelete,
                      toLowerCase1,
                      toggleViewModal,
                      toggleRtCanvas,
                      toggleOrderFormModel,
                      toggleInvoiceHistoryModel,
                      designersList,
                      salesList,
                      path
                    )}
                    data={
                      customers.hasOwnProperty("docs")
                        ? customers.docs
                        : customers
                    }
                    // cellEdit={ cellEditFactory({ mode: 'click' }) }
                  >
                    {({ paginationProps, paginationTableProps }) => (
                      <ToolkitProvider
                        keyField="_id"
                        data={
                          customers.hasOwnProperty("docs")
                            ? customers.docs
                            : customers
                        }
                        columns={Columns(
                          toggle,
                          handleValidDate,
                          handleVectorClick,
                          onClickDelete,
                          toLowerCase1,
                          toggleViewModal,
                          toggleRtCanvas,
                          toggleOrderFormModel,
                          toggleInvoiceHistoryModel,
                         
                          designersList,
                          salesList,
                          path
                        )}
                        bootstrap4
                        search
                      >
                        {toolkitProps => (
                          <React.Fragment>
                            {/* <Row> */}
                            <Col sm="12">
                              <FilterComponentForCustomers
                                handleFilterClick={handleFilterClick}
                                filter={filterFunction(1)}
                              />
                            </Col>
                            {/* </Row> */}
                            <Row>
                              <Col xl="12">
                                <div className="table-responsive">
                                  <BootstrapTable
                                    remote={{
                                      filter: true,
                                      pagination: true,
                                      sort: false,
                                      cellEdit: false,
                                    }}
                                    keyField="_id"
                                    responsive
                                    bordered={true}
                                    striped={true}
                                    defaultSorted={defaultSorted}
                                    // selectRow={selectRow}
                                    classes={
                                      "table align-middle table-nowrap table-check"
                                    }
                                    
                                    headerWrapperClasses={"table-light"}
                                    {...toolkitProps.baseProps}
                                    {...paginationTableProps}
                                    onTableChange={handleTableChange}
                                    cellEdit={cellEditFactory({
                                      mode: "dbclick",
                                      blurToSave: true,
                                      afterSaveCell: handleChange,
                                    })}
                                    expandRow={expandRow}
                                    ref={node}
                                  />
                                </div>
                              </Col>
                            </Row>
                            <Row className="align-items-md-center mt-30">
                              <Col className="pagination pagination-rounded justify-content-end mb-2 inner-custom-pagination">
                                <PaginationListStandalone
                                  {...paginationProps}
                                />
                              </Col>
                            </Row>
                          </React.Fragment>
                        )}
                      </ToolkitProvider>
                    )}
                  </PaginationProvider>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <GenerateInvoice
          isOpen={open}
          toggle={toggleRtCanvas}
          orderObject={orderObject}
        />
           {/* <OrderForm  toggle={toggleOrderFormModel} isOpen={orderFormModelOpen} /> */}
       <OrdersModel toggle={toggleOrderFormModelClose} isOpen={orderFormModelOpen} value={recvalue}/>
       <InvoiceHistoryModel toggle={toggleInvoiceHistoryModel} isOpen={toggleInvoiceHistory} value={invoiceObject} />
      </div>
    </React.Fragment>
  )

}


Customers.propTypes = {
  orders: PropTypes.array,
  onGetCustomers: PropTypes.func,
  onAddNewVector: PropTypes.func,
  onDeleteVector: PropTypes.func,
  onUpdateVector: PropTypes.func,
}

export default withRouter(Customers)
